export const DEVICES_VIEW = 'devices_view';
export const DEVICES_CREATE = 'devices_create';
export const DEVICES_EDIT = 'devices_edit';

export const DEVICE_TAB_MOBILE = 'mobile';
export const DEVICE_TAB_TV = 'tv';

export const MOBILE_DEVICE_TYPE_PRIMARY = 'Primary';
export const MOBILE_DEVICE_TYPE_SECONDARY = 'Secondary';

export const MOBILE_DEVICE_FILTER_MENU = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Device Type',
    field: 'deviceType',
    subMenu: [
      { id: 'Primary', name: 'Primary', selected: false },
      { id: 'Secondary', name: 'Secondary', selected: false },
    ],
    hideSearch: true,
  },
];

export const MOBILE_SORT_OPTIONS = [
  { label: 'Room Number', field: 'roomNo' },
  { label: 'Guest Name', field: 'guestName' },
];

// not used as its managed dynamically
export const DEVICE_API_URL = 'https://mayfairproxy.hudini.io/api/v1/';

export const DEVICE_STATUS = {
  ON: {
    className: 'text-green',
    label: 'On',
    loader: false,
  },
  OFF: {
    className: 'text-red',
    label: 'Off',
    loader: false,
  },
  ON_INPROGRESS: {
    className: 'text-gray',
    label: 'Switching On',
    loader: true,
  },
  OFF_INPROGRESS: {
    className: 'text-gray',
    label: 'Switching Off',
    loader: true,
  },
  RESTART_INPROGRESS: {
    className: 'text-gray',
    label: 'Restarting',
    loader: true,
  },
};
